import { render, staticRenderFns } from "./FieldValueList.vue?vue&type=template&id=8e22f724&"
import script from "./FieldValueList.vue?vue&type=script&lang=js&"
export * from "./FieldValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports